import React from "react";
import "./landing.css";

/* Small, consistent line icons so the feature grid reads as one set
   (mixing the app's PNG location icons looked inconsistent here). */
const icons = {
  signout: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  attendance: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  ),
  emergency: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  school: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18" />
      <path d="M5 21V8l7-5 7 5v13" />
      <path d="M9 21v-6h6v6" />
    </svg>
  ),
  lending: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  student: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  ),
};

const features = [
  {
    icon: icons.signout,
    title: "Smart Sign-Outs",
    text: "Students sign out to the bathroom, nurse, office, or anywhere in seconds. Every trip is time-stamped and tied to the right teacher and room.",
  },
  {
    icon: icons.attendance,
    title: "One-Tap Attendance",
    text: "Students tap their name to check in. Roll call is done in moments, with an exact arrival time logged automatically.",
  },
  {
    icon: icons.emergency,
    title: "Emergency Mode",
    text: "Trigger a school-wide checklist during a drill or lockdown. Account for every student in real time, from any classroom.",
  },
  {
    icon: icons.school,
    title: "School-Wide Visibility",
    text: "See where students are across the whole building — not just your own room. Tenant-isolated and secure for every school.",
  },
  {
    icon: icons.lending,
    title: "Lending & Library",
    text: "Track Chromebooks, books, and classroom supplies. Know who has what and when it's due back.",
  },
  {
    icon: icons.student,
    title: "Student Self-Service",
    text: "A dedicated student portal lets kids sign themselves out and check in — no lines at the teacher's desk.",
  },
];

const FeatureSection = () => {
  return (
    <section className="landing-section landing-section--tint">
      <div className="landing-inner">
        <div className="landing-section-head">
          <span className="landing-eyebrow">Everything in one place</span>
          <h2>Run your classroom — and your school — with confidence</h2>
          <p className="landing-lead">
            ClassBoon replaces a stack of paper sheets, spreadsheets, and forms
            with one clean system every teacher can pick up in minutes.
          </p>
        </div>

        <div className="feature-grid">
          {features.map((f) => (
            <div className="feature-card" key={f.title}>
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
